export default [
  {
    path: '/main/frotix-management',
    meta: {
      tag: 'frotixmanagement',
      name: 'Gestão Frotix',
      breadcrumb: 'Gestão Frotix'
    },
    component: () => import(/* webpackChunkName: "frotix-management" */ '@/views/main/frotix-management/Index.vue'),
  }
]
